export const uppercaseKeysInResObj = <K extends string, T extends Record<K, string | object>>(
  data: T,
) =>
  (Object.keys(data) as unknown as K[]).reduce((acc, key) => {
    // humps returns the keys in camelCase, but we need case the same as the enum EMetal;
    acc[key.toUpperCase() as K] = data[key];

    return acc;
  }, {} as T);
